import { render, staticRenderFns } from "./courses-encite.vue?vue&type=template&id=267c4140"
import script from "./courses-encite.vue?vue&type=script&lang=js"
export * from "./courses-encite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports